'use client'
/**
 * Formats a version string according to the specified format pattern.
 *
 * @param version - The version string in the format "x.y.z" (e.g., "1.2.3")
 * @param format - The desired output format using combinations of "major", "minor", and "patch"
 * @returns The formatted version string
 *
 * @example
 * formatVersion("1.2.3", "major.minor") // returns "1.2"
 * formatVersion("1.2.3", "major") // returns "1"
 * formatVersion("1.2.3", "major.minor.patch") // returns "1.2.3"
 */
const formatVersion = (version, format) => {
    const versionMap = Object.fromEntries(['major', 'minor', 'patch'].map((unit, index) => [
        unit,
        version.split('.')[index],
    ]));
    return format
        .split('.')
        .map((unit) => versionMap[unit])
        .join('.');
};

export { formatVersion };
